import { ReactNode, useEffect, useRef } from "react";
import { createFastContext } from "../../../contexts/createFastContext2";
import { getTimelineFromActivityLog } from "./contants";

const InitState = () => {
    const initRef = useRef({
        ...getTimelineFromActivityLog(),
        set: setProcessData()
    })
    useEffect(() => {
        const { start, finish, set } = initRef.current;
        set({ start, finish })
    }, [])

    return null;
}

interface IState {
    start: number
    finish: number
}

const {
    Provider,
    useStore: useProcessData,
    setStore: setProcessData,
    getStore: getProcessData,
    callEvent: callEventProcessData
} = createFastContext<IState>({
    start: 0,
    finish: 0,
});

const ProcessDataProvider = ({ children, ...args }: { children: ReactNode } & Partial<IState>) => {

    return <Provider props={{ ...args }}>
        <InitState />
        {children}
    </Provider>
}

export { callEventProcessData, getProcessData, ProcessDataProvider, setProcessData, useProcessData };

